import React from 'react';
import AttachmentContent from "./attachment-content.jsx";

const UpdateContent = ({element}) => {
    const updateData = JSON.parse(element?.diff ?? "{}");

    return (
        <tr className="update-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">

                    <thead>
                        <tr className='text-left'>
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "35%"}}>Novo</th>
                            <th style={{width: "35%"}}>Antigo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.entries(updateData).map(([key, value], index) => {

                            if (key === "attendance_attachment") {
                                return (
                                    <AttachmentContent key={index} attachments={Object.values(value)} isUpdate/>
                                );
                            }

                            let label = key;
                            if (key.trim() === "attendance_lastuser") label = "Usuário que realizou alteração";

                            return (
                                <tr key={index} className=" text-left">
                                    <td>{label}</td>
                                    <td className={'break-all! whitespace-normal'}>{value?.new ?? ""}</td>
                                    <td className={'break-all! whitespace-normal'}>{value?.old ?? ""}</td>
                                </tr>
                            );
                        })}
                    </tbody>

                </table>
            </td>
        </tr>
    );
};

export default UpdateContent;